import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const DarkModeToggle = () => {
   const { darkMode, toggleDarkMode } = useDarkMode();

   return (
      <button
         onClick={toggleDarkMode}
         className="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-300 transition-colors dark:bg-dark-accent"
         aria-label="Toggle dark mode"
         role="switch"
         aria-checked={darkMode}
      >
         <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
               darkMode ? 'translate-x-6' : 'translate-x-1'
            }`}
         />
         <span className="sr-only">
            {darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
         </span>
      </button>
   );
};

export default DarkModeToggle;
